export default __webpack_public_path__ + "static/media/Oman_logo.575e1559.png";